import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Alert, Platform, Linking, ScrollView, View} from 'react-native';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import * as StoreReview from 'expo-store-review';
import Rate, {AndroidMarket} from 'react-native-rate';

import FastImage from 'src/Utils/FastImage';

import {getExplorerPassForUser} from 'src/Utils/explorerPassHelper.js';

///////////////////////////
///////////// components

import {BottomTab, BottomTabButton} from 'src/Modules/TabViews';

import {BodyText, PlayerScoreCard} from 'src/Modules/CommonView';
import {apiCESReview, apiUpdateUserBadges} from 'src/Utils/apiCalls';
import {leaveHuntReview} from 'src/Utils/huntFunctions';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {getReduxState} from '../Utils/helpers';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

const starsIcons = require('src/Images/Icons/challengeStars.png');

const HuntFinished = () => {
  const groupInfo = useSelector((state) => state.groupInfo || {});
  const characters = useSelector((state) => state.themeInfo?.characters || {});
  const playTestState = useSelector((state) => state.app_info?.playTestState);
  const userId = useSelector((state) => state.user?.userId);
  const {teamName, players = {}, eventId} = groupInfo;

  const navigateSocial = () => {
    navigationRef.navigate('HuntSocialBonuses');
  };

  const ratingRequest = () => {
    if (Platform.OS == 'android') {
      const options = {
        GooglePackageName: 'com.barhuntv2',
        preferredAndroidMarket: AndroidMarket.Google,
        preferInApp: true,
        openAppStoreIfInAppFails: true,
      };
      Rate.rate(options, (success) => {
        if (success) {
          // this technically only tells us if the user successfully went to the Review Page. Whether they actually did anything, we do not know.
        }
      });
    } else if (StoreReview.isAvailable) {
      StoreReview.requestReview();
    } else {
      let reviewUrl =
        Platform.OS == 'ios'
          ? 'https://itunes.apple.com/us/app/lets-roam-scavenger-hunts/id1338916789?ls=1&mt=8'
          : 'market://details?id=com.barhuntv2&hl=en_US';
      Alert.alert(
        'LEAVE REVIEW',
        'We are glad you enjoyed the hunt. Can you please leave us a review?',
        [
          {text: 'Maybe Later', onPress: () => null},
          {text: 'Yes', onPress: () => Linking?.openURL(reviewUrl)},
        ],
        {cancelable: false},
      );
    }
  };

  const navigateReview = () => {
    const {groupId, huntId} = groupInfo;

    navigationRef.navigate('ReviewModal', {
      primaryRatingText: 'How Would You Rate This Hunt?',
      secondaryRatingText: 'How Would You Rate Our App?',
      superlativesText: 'What were your favorite things about this hunt?',
      superlativeOptions: [
        'Fun',
        'Educational',
        'Challenging',
        'Easy',
        'Kid Friendly',
        'Exciting',
        'Romantic',
        'Walkable',
        'Unique',
      ],
      reviewParams: {
        userId,
        groupId,
        hunt_id: huntId,
        r_role: null,
        OS: Platform.OS,
      },
      reviewSubmit: async (params) => {
        const {star_rating = 0, star_rating_2 = 0, comment} = params;

        const review = await apiCESReview({
          groupId,
          userId,
          huntId,
          r_hunt: star_rating,
          r_app: star_rating_2,
          additionalComments: comment,
          type: 'regular',
        });

        console.log('leaving review');

        leaveHuntReview({
          userId,
          groupId,
          r_hunt: star_rating,
          r_app: star_rating_2,
          r_role: null,
          OS: Platform.OS,
        });

        if (star_rating + star_rating_2 > 8) {
          ratingRequest();
        }

        setTimeout(() => {
          navigateSocial();
        }, 800);

        return review;
      },
    });
  };

  useEffect(() => {
    const {players = {}} = groupInfo;

    apiUpdateUserBadges();

    // if (
    //   !groupInfo?.huntPostCardFinished &&
    //   (!eventId ||
    //     eventId?.includes?.('bach') ||
    //     eventId?.includes?.('birt')) &&
    //   countryCode == 'US'
    // ) {
    //   return navigationRef.navigate('HuntPostCard');
    // }

    if (!players[userId].reviews) {
      // Alert.alert('hi');
      setTimeout(() => {
        navigateReview();
      }, 1000);
    } else if (players[userId].reviews && !players[userId].bonuses) {
      // Alert.alert('hi');
      navigateSocial();
      setTimeout(() => {
        navigateSocial();
      }, 1000);
    } else {
      // Alert.alert('hi');
    }
  }, []);

  useEffect(() => {
    // if (!groupInfo?.huntPostCardFinished && !eventId && countryCode == 'US') {
    //   return navigationRef.navigate('HuntPostCard');
    // }
  }, [groupInfo?.huntPostCardFinished, eventId]);

  const playersList = Object.values(players).sort((a, b) => {
    if (a?.parentUserId === userId && b?.parentUserId === userId) {
      if (a?.points > b?.points) {
        return -1;
      }
      if (b?.points > a?.points) {
        return 1;
      }
      return 0;
    }
    if (a?.parentUserId === userId) {
      return -1;
    }
    if (a?.userId === userId) {
      return -1;
    }

    if (a?.points > b?.points) {
      return 1;
    }
    return 0;
  });

  const insets = useSafeAreaInsets();

  return (
    <View style={{flex: 1}}>
      <ScrollView style={{flex: 1}}>
        <GroupResults groupInfo={groupInfo} />
        <View
          style={{
            flex: 1,
            paddingVertical: 10,
            backgroundColor: global?.color?.white1,
            minHeight: 300,
          }}>
          <BodyText
            text={`${teamName} Results:`}
            textStyle={{fontWeight: '700', marginTop: 5}}
          />
          {!!playersList?.length &&
            playersList?.map?.((player, index) => {
              return (
                <PlayerScoreCard
                  key={`player_score_${index}`}
                  player={player}
                  index={index}
                  color={
                    userId === player.parentUserId
                      ? global?.color?.orange
                      : false
                  }
                  character={player.character}
                  characters={characters}
                  handlePress={() => {
                    navigationRef.navigate('HuntFinishedPlayer', {
                      userId: player.userId,
                    });
                  }}
                />
              );
            })}
        </View>
      </ScrollView>
      <View style={{backgroundColor: 'white'}}>
        <BottomTab
          height={55}
          tabStyle={{
            alignItems: 'flex-start',
            marginBottom: insets.bottom,
          }}>
          <BottomTabButton
            text={'Home'}
            iconName={'award'}
            iconPack={'FeatherIcon'}
            handlePress={() => {
              try {
                const pass = getExplorerPassForUser(
                  getReduxState(['user']),
                  'HuntFinished',
                );
                if (!pass && playTestState == false) {
                  Alert.alert(
                    `You unlocked a free trial for a Let's Roam Membership`,
                    'Get unlimited scavenger hunts for you plus your 5 of your friends!',
                    [
                      {
                        text: 'Check out Perks',
                        onPress: () =>
                          navigationRef.navigate('PuchaseModal', {
                            showMembershipOnly: true,
                          }),
                      },
                    ],
                  );
                } else {
                  navigationRef.navigate(
                    'LandingPageMain',
                    {},
                    'Hunt Finished',
                  );
                }
              } catch (error) {
                navigationRef.navigate(
                  'LandingPageMain',
                  {},
                  'Hunt Finished Error',
                );
              }
            }}
            buttonStyle={{marginTop: 5}}
            active={false}
          />
          {!!eventId && (
            <BottomTabButton
              text={'Leaderboard'}
              iconName={'bar-chart-2'}
              iconPack={'FeatherIcon'}
              handlePress={() => navigationRef.navigate('EventDashboard')}
              buttonStyle={{marginTop: 5}}
              active={false}
            />
          )}
          <BottomTabButton
            text={'Photos'}
            iconName={'aperture'}
            iconPack={'FeatherIcon'}
            handlePress={() => navigationRef.navigate('HuntPhotos')}
            buttonStyle={{marginTop: 5}}
            active={false}
          />
        </BottomTab>
      </View>
    </View>
  );
};

const GroupResults = ({groupInfo}) => {
  const {width} = useWindowDimensionsSafe();
  const {rankAtFinish, score = 0} = groupInfo;
  const huntLength = useSelector((state) => state.game_v2?.huntLength);

  const distanceSteps =
    (huntLength && Math?.floor(huntLength * 2112).toLocaleString()) || '';
  const formatRank = (rank, score) => {
    const formatted = {
      1: '1st',
      2: '2nd',
      3: '3rd',
    };

    let output = (formatted[rank] || `${rank}th`) + ' Place';
    if (rank > 10) {
      output = `You beat ${
        100 - Math?.round(Math?.min(rank, 120) / 2)
      }% of teams`;
    }

    if (score < 2000) {
      output = `You didn't make the leaderboard`;
    }

    return output;
  };

  return (
    <View
      style={{
        flex: 1,
        paddingBottom: 20,
        backgroundColor: global?.color?.white,
      }}>
      <View style={{alignItems: 'center'}}>
        <FastImage
          style={{
            width: 300,
            height: 130,
          }}
          source={starsIcons}
          resizeMode={FastImage?.resizeMode?.contain}
        />
      </View>
      <BodyText
        text={'CONGRATULATIONS!'}
        textStyle={{
          fontSize: 44,
          lineHeight: 48,
          fontFamily: global?.font.gothic,
          textAlign: 'center',
        }}
      />
      <BodyText
        text={'YOUR TEAM FINISHED THIS HUNT WITH'}
        textStyle={{
          fontSize: 22,
          lineHeight: 26,
          fontFamily: global?.font.gothic,
          textAlign: 'center',
        }}
      />
      <BodyText
        text={`${score.toLocaleString()} PTS`}
        textStyle={{
          fontSize: 80,
          lineHeight: 84,
          fontFamily: global?.font.gothic,
          textAlign: 'center',
        }}
      />
      {(!!distanceSteps || !!rankAtFinish) && (
        <View
          style={{
            backgroundColor: global?.color?.orange,
            marginHorizontal: 10,
            paddingVertical: 5,
            width: width - 20,
          }}>
          <BodyText
            text={`Team Results`}
            textStyle={{
              marginLeft: 10,
              color: global?.color?.white,
              marginTop: 5,
            }}
          />
        </View>
      )}
      {(!!distanceSteps || !!rankAtFinish) && (
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginTop: 5,
          }}>
          {!!distanceSteps && (
            <View>
              <BodyText
                text={'Steps'}
                textStyle={{
                  textAlign: 'center',
                  fontSize: 14,
                  fontWeight: '700',
                }}
              />
              <BodyText
                text={distanceSteps}
                textStyle={{textAlign: 'center', fontSize: 14, marginTop: 3}}
              />
            </View>
          )}
          {!!rankAtFinish && (
            <View>
              <BodyText
                text={'Leaderboard'}
                textStyle={{
                  textAlign: 'center',
                  fontSize: 14,
                  fontWeight: '700',
                }}
              />
              <BodyText
                text={formatRank(rankAtFinish, score)}
                textStyle={{textAlign: 'center', fontSize: 14, marginTop: 3}}
              />
            </View>
          )}
        </View>
      )}
    </View>
  );
};

export default HuntFinished;
